import React from "react";

import { Box } from "@mui/material";

import RichTextEditor from "./RichTextEditor";

const InfoRoundForm = ({ config, onChange }) => {
  const handleTitleChange = (value) => {
    onChange({ title: value });
  };

  const handleContentChange = (value) => {
    onChange({ content: value });
  };

  return (
    <Box sx={{ padding: 2 }}>
      <RichTextEditor
        title={config.title || ""}
        content={config.content || ""}
        onTitleChange={handleTitleChange}
        onContentChange={handleContentChange}
        showPreview={true}
        showToolbar={true}
      />
    </Box>
  );
};

export default InfoRoundForm; 